import type { ApiResponse } from '../../creator-sdk';
import { post } from '../../network/api-service';
import type DbModule from '../db';
import type AppCheckModule from '../app-check';
import type AccountModule from '../account';

export interface DeleteUserContentApiRequestPayload {
    userId?: string;

    tokenName: string;
    bannedUserId: string;
    reason?: string;
    reasonText?: string;
}

export interface TipCommentApiRequestPayload {
    userId: string;

    tokenName: string;
    commentId: string;
    amount: number;
}

export default class UpvoteService {
    private contractName: string;
    private domainName: string;
    private dbModule: DbModule;
    private appCheckModule: AppCheckModule;
    private accountModule: AccountModule;
    constructor(contractName: string, domainName: string, appCheckModule: AppCheckModule, dbModule: DbModule, accountModule: AccountModule) {
        this.contractName = contractName;
        this.domainName = domainName;
        this.dbModule = dbModule;
        this.appCheckModule = appCheckModule;
        this.accountModule = accountModule;
    }

    async deleteUserContent(payload: DeleteUserContentApiRequestPayload): Promise<ApiResponse<string>> {
        const token = await this.accountModule.getIdToken();
        const { data } = await post<ApiResponse<any>>(
            '/content/delete',
            payload,
            {
                Authorization: `Bearer ${token}`,
                'X-Firebase-AppCheck': await this.appCheckModule.getAppCheckToken(),
            },
            false,
        );
        return data;
    }

    // async tipComment(payload: TipCommentApiRequestPayload): Promise<ApiResponse<PostComment>> {
    //     const token = await this.accountModule.getIdToken();
    //     const { data } = await post<ApiResponse<any>>(
    //         '/comment/tipping',
    //         payload,
    //         {
    //             Authorization: `Bearer ${token}`,
    //             'X-Firebase-AppCheck': await this.appCheckModule.getAppCheckToken(),
    //         },
    //         false,
    //     );
    //     return data;
    // }
}
